import "../css/card_design.css";
import "../css/Nav design.css";
import OccupationDropdown from "./Occupation";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import UpdateDetailsResponse from "../model/response/UpdateDetailsResponse";
import UpdateDetails from "../model/request/UpdateDetails";
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { Oval } from "react-loader-spinner";



function Family_details() {
    var location = useLocation();
    var { profile } = location.state || {};
    const [activeuser, setActiveUser] = useState([]);
    const [family_Values, setFamilyvalues] = useState(profile.family_Values_Id);
    const [family_Type, setFamilytype] = useState(profile.family_TypeId);
    const [family_Status, setFamilystatus] = useState(profile.family_StatusId);
    const [father_occupation, setFather_occupation] = useState(profile.father_OccupationId);
    const [mother_Occupation, setMother_occupation] = useState(profile.mother_OccupationId);
    const [brother, setBrother] = useState(profile.no_Of_Brothers);
    const [brother_married, setBrother_married] = useState(profile.brothers_Married);
    const [sister, setSister] = useState(profile.no_Of_Sister);
    const [sister_married, setSister_married] = useState(profile.siters_Married);
    // const [familyLocation, setFamilylocation] = useState(profile.lives_In);
    const [isLoading, setIsLoading] = useState(false)


    const navigation = useNavigate()

    function clicktoEditprofile() {
        navigation('/Editprofile')
        setIsLoading(true);
    }


    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }


    useEffect(() => {

    }, []);

    function FamilyDetailsAPICall() {
        setIsLoading(true);
        var request = new UpdateDetails();
        request.user_Id = loginVal.user_Id;
        request.family_Value = parseInt(family_Values);
        request.family_Type = parseInt(family_Type);
        request.family_Status = parseInt(family_Status);
        request.father_Occupation = parseInt(father_occupation);
        request.mother_Occupation = parseInt(mother_Occupation);
        request.noOfBrothers = parseInt (brother);
        request.brotherMarried = parseInt (brother_married);
        request.noOfSisters = parseInt (sister);
        request.sisterMarried =parseInt (sister_married);

        console.log("Response:", JSON.stringify(request));
        axios.put(
            ApiConfig.getUrl("User/updateFamily"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                //  console.log("statusCode:", login.user_Id);

                const profileVal = UpdateDetailsResponse.fromJson(api.response);

                console.log("Response:", JSON.stringify(profileVal));
                setActiveUser(profileVal);
                showToast("Update successfull");
                setIsLoading(false);

            })
            .catch(error => {
                console.error("Error:", error);
                showToastFailed("Update Error");
                setIsLoading(false);
            });
    }

    console.log("sfdfds" + brother_married);

    const disableRightClick = (e) => {
    e.preventDefault();
  };

    return (
        <>

            <div className="fullview" style={{ fontFamily: " font-family: Arial, Helvetica, sans-serif" }} onContextMenu={disableRightClick}>
                <ToastContainer />
                {isLoading && (
                    <div className="loader-overlay">
                        <Oval
                            height={60}
                            width={60}
                            color="#ffffff"
                            secondaryColor="#cccccc"
                            strokeWidth={4}
                            visible={true}
                        />
                    </div>
                )}
                <div className="container border p-5">
                    <div className='topic-row'>
                        <h2>Family Details</h2>
                        <button className="Edit-btn" onClick={clicktoEditprofile}>Close</button></div>
                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="education" value="body_Type" className="education" >Family Value :</label></div>

                        <div className="card-column">
                            <div>
                                <select id="body_Type" className="input_box" value={family_Values} onChange={(e) => setFamilyvalues(e.target.value)}>
                                   
                                    <option value="1">Orthodox </option>
                                    <option value="2">Traditional</option>
                                    <option value="3">Moderate</option>
                                    <option value="4">Liberal</option>
                                </select>
                            </div>

                        </div>
                    </div>

                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="education" className="education" >Family Type :</label></div>
                        <div className="card-column">
                            <div>
                                <select id="body_Type" className="input_box" value={family_Type} onChange={(e) => setFamilytype(e.target.value)}>
                                   
                                    <option value="1">Joint Family </option>
                                    <option value="2">Nuclear Family</option>
                                    <option value="3">Others</option>
                                </select>
                            </div>

                        </div>
                    </div>

                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="education" className="education" >Family Status :</label></div>
                        <div className="card-column">
                            <div>
                                <select id="body_Type" className="input_box" value={family_Status} onChange={(e) => setFamilystatus(e.target.value)}>
                                  
                                    <option value="1">Middle Class </option>
                                    <option value="2">Upper Middle Class</option>
                                    <option value="3">High Class</option>
                                    <option value="4">Rich/Affluent</option>

                                </select>
                            </div>

                        </div>
                    </div>
                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="occupation" className="occupation" >Father's Occupation :</label></div>
                        <div className="card-column">
                            <div>
                                <select id="occupation" className="input_box" value={father_occupation} onChange={(e) => setFather_occupation(e.target.value)}>
                                    <option value="">--select--</option>
                                    <option value="1">Employed </option>
                                    <option value="2">Bussiness Man</option>
                                    <option value="3">Professional</option>
                                    <option value="4">Retired</option>
                                    <option value="5">Not Employed</option>
                                    <option value="6">Passed Away</option>
                                </select>
                            </div>
                        </div>

                        {/* <div><OccupationDropdown value={father_occupation}
                    onChange={(e) => setFather_occupation(e.target.value)} /></div> */}

                    </div>
                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="occupation" className="occupation" >Mother's Occupation :</label></div>
                        <div className="card-column">
                            <div>
                                <select id="occupation" className="input_box" value={mother_Occupation} onChange={(e) => setMother_occupation(e.target.value)}>
                                    <option value="">--select--</option>
                                    <option value="1">Employed </option>
                                    <option value="8">Bussiness Woman</option>
                                    <option value="3">Professional</option>
                                    <option value="4">Retired</option>
                                    <option value="6">Passed Away</option>
                                    <option value="7">Homemaker</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    {/* <div><OccupationDropdown value={mother_Occupation} onChange={(e) => setMother_occupation(e.target.value)} /></div> */}

                    <div className="card-row">
                        <div className="left-label">
                            <label>No. of Brothers :</label>
                        </div>
                        <div>
                            <select className="input_box"
                                value={brother}
                                onChange={(e) => {
                                    const total = parseInt(e.target.value);
                                    setBrother(total);
                                    if (brother_married > total) {
                                        setBrother_married(total);
                                    }
                                }}>

                                <option value="">-Select-</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select>
                        </div>
                    </div>

                    <div className="card-row">
                        <div className="left-label">
                            <label>No. of Brothers Married :</label>
                        </div>
                        <div>
                            <select
                                className="input_box"
                                value={brother_married}
                                onChange={(e) => setBrother_married(parseInt(e.target.value))}
                            >
                                <option value="">-Select-</option>
                                {brother === 0 &&
                                    <option value="0">0</option>
                                }
                                {brother === 1 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option> </>}
                                {brother === 2 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                </>}
                                {brother === 3 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </>}
                                {brother === 4 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </>}
                                {brother === 5 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </>}
                                {brother === 6 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </>}
                            </select>
                        </div>
                    </div>

                    <div className="card-row">
                        <div className="left-label">
                            <label>No. of Sisters :</label>
                        </div>
                        <div>
                            <select
                                className="input_box"
                                value={sister}
                                onChange={(e) => {
                                    const total = parseInt(e.target.value);
                                    setSister(total);
                                    if (sister_married > total) {
                                        setSister_married(total);
                                    }
                                }}
                            >
                                <option value="">-Select-</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select>
                        </div>
                    </div>

                    <div className="card-row">
                        <div className="left-label">
                            <label>No. of Sisters Married :</label>
                        </div>
                        <div>
                            <select
                                className="input_box"
                                value={sister_married}
                                onChange={(e) => setSister_married(parseInt(e.target.value))}
                            >
                                <option value="">-Select-</option>
                                {sister === 0 &&
                                    <option value="0">0</option>
                                }
                                {sister === 1 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option></>}
                                {sister === 2 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                </>}
                                {sister === 3 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </>}
                                {sister === 4 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </>}
                                {sister === 5 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </>}
                                {sister === 6 && <>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </>}
                            </select>
                        </div>
                    </div>


                   
                    <div className="btn-group mt-2 ">
                        <button onClick={FamilyDetailsAPICall} style={{ backgroundColor: "var(--primary-color)" }} className="btn">Save</button>
                        <button style={{ backgroundColor: "lightgrey" }} className="btn" onClick={clicktoEditprofile}> Cancel</button>
                    </div>
                </div>
            </div>
            <footer className='bg-dark text-white text-center'>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </>
    );
}
export default Family_details;